import { Link } from 'react-router-dom';
import { statsData } from '@/mocks/home';

export default function StatsBar() {
  return (
    <section className="w-full bg-primary-500 py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {statsData.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 mb-3">
                <i className={`${stat.icon} text-lg md:text-xl text-background-50`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CTABanner() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          无需注册，立即畅享海量高清视频
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-xl mx-auto">
          福利视频网站每日更新200+精选内容，覆盖电视剧、电影、综艺、动漫等多种类型，全免费、无广告干扰，让观影体验更纯粹。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dianshi"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap"
          >
            开始观影
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50 hover:bg-background-200 text-foreground-800 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}